module.exports = __webpack_public_path__ + "static/media/Vec vectores_Rendimiento esperado amarillo.15b234ca.svg";